<template>
    <div class=" mb-5">
        <div class="border pb-3">
            <h3 class="text-center my-3">OtherHistory</h3>
            <div class="row mb-2">
                <div class="col-sm-12">
                    <a  class="py-2 px-3" data-bs-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="false" aria-controls="collapseExample1">
                        2022.12.13施設ご利用分
                    </a>
                </div>
                <div class="col-sm-12 collapse mt-2" id="collapseExample1">
                        <div class="row">
                            <div class="col-6 col-sm-4 text-center">
                                <div>
                                    <img src="@/assets/dummy_tennis_001.jpg" class="w-100">
                                </div>
                                <div>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">曲川 太郎</p>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">10:00-15:00</p>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">テニスコートA</p>
                                </div>
                            </div>
                            <div class="col-6 col-sm-4 text-center">
                                <div>
                                    <img src="@/assets/dummy_privateroom_001.jpg" class="w-100">
                                </div>
                                <div>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">曲川 太郎</p>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">19:00-22:00</p>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">個室A</p>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-sm-12">
                    <a  class="py-2 px-3" data-bs-toggle="collapse" href="#collapseExample2" role="button" aria-expanded="false" aria-controls="collapseExample2">
                        2022.12.13施設ご利用分
                    </a>
                </div>
                <div class="col-sm-12 collapse mt-2" id="collapseExample2">
                        <div class="row">
                            <div class="col-6 col-sm-4 text-center">
                                <div>
                                    <img src="@/assets/dummy_tennis_001.jpg" class="w-100">
                                </div>
                                <div>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">曲川 太郎</p>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">10:00-15:00</p>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">テニスコートA</p>
                                </div>
                            </div>
                            <div class="col-6 col-sm-4 text-center">
                                <div>
                                    <img src="@/assets/dummy_privateroom_001.jpg" class="w-100">
                                </div>
                                <div>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">曲川 太郎</p>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">19:00-22:00</p>
                                    <p class="py-2 mt-0 mb-0 bg-dark text-white border-white border-top">個室A</p>
                                </div>
                            </div>
                        </div>


                </div>
            </div>
        </div>
</div>
</template>

<script>
// import BsPageTitle from '../molecules/BsPageTitle.vue'

export default {
name: 'BsDashBoardView',
data: function () {
    return {
        'tab_active': 'drive',//or th ead
    }
},
props: {
    displayClass: {
        type: String,
        default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
    },
},
components: {
    // BsPageTitle,
},
methods: {
    tab_switch_action(tab) {
    this.tab_active = tab;
    },
},
computed: {
    tabDisplay: function () {
    const self_tab_active = this.tab_active;
    return function (tab) {
        let tabClass = 'd-none ';
        if(self_tab_active == tab){
        tabClass = 'd-block';
        }
        return tabClass;
    }

    },
    tab_switch: function() {
    const self_tab_active = this.tab_active;
    return function (tab) {
        let tabClass = 'nav-link ';
        console.log('tab_switch', self_tab_active);
        if(self_tab_active == tab){
        tabClass += 'active';
        }
        return tabClass;
    }
    },
}
}
</script>
